import { useTranslation } from 'react-i18next';
import { Card } from '../../shared/Card/Card';
import { CardHeaderSkeleton } from '../../shared/CardHeader/CardHeaderSkeleton';
import { Shimmer } from '../../shared/Shimmer/Shimmer';
import styles from './ExceptionsSkeleton.module.css';

/** Loading state for {@link ExceptionsCenter} — three exception rows. */
export function ExceptionsSkeleton() {
  const { t } = useTranslation();
  return (
    <Card aria-busy="true" aria-label={t('productivity.skeleton.loading')}>
      <CardHeaderSkeleton />
      <div className={styles.list}>
        {Array.from({ length: 3 }, (_, i) => (
          <div key={i} className={styles.row}>
            <Shimmer className={styles.severityDot} wave={i * 0.08} />
            <div className={styles.body}>
              <Shimmer className={styles.title} wave={i * 0.08} />
              <Shimmer className={styles.detail} wave={i * 0.08} />
            </div>
            <Shimmer className={styles.action} wave={i * 0.08} />
          </div>
        ))}
      </div>
    </Card>
  );
}